export const getTennisLabels = (sportId, scores, dict) => {
    if (scores.length > 0) {
        const scoreLabels = scores.map((el, index) => (index + 1).toString());
        scoreLabels[scoreLabels.length - 1] = dict.myBetsDictionary.Point;
        return scoreLabels;
    }
    return [];
};
//# sourceMappingURL=getTennisLabels.js.map